// extracted by mini-css-extract-plugin
export default {"input":"P8-z","button":"Q8-z","selected":"R8-z","unavailable":"S8-z","oos":"T8-z","image":"U8-z","paperCutDisabledOverlay":"V8-z"};